(function() {
	'use strict';

	/**
	 * Start with Food and pair Wine
	 */
	angular
		.module('pwc.controllers')
		.controller('PairFoodController', PairFoodController);

	PairFoodController.$inject = ['lodash', '$mdDialog', 'systemPouch', 'userPouch', 'Wine', '$log'];

	function PairFoodController(lodash, $mdDialog, systemPouch, userPouch, Wine, $log){

		/* jshint validthis: true */
		var self = this;

		// The user's search input
		self.search = {
			"name": ''
		};

		// user wines in cellar
		self.wines = [];

		// The food the user selected to pair with wines.
		self.selectedFood = null;

		// the paired wines for the selected food.
		self.distinctions = [];

		// all foods from db
		self.foods = [];

		// all distinctions from db
		self.allDistinctions = [];

		self.pairFood = pairFood;
		self.openHelp = openHelp;
		self.openWinesInCellar = openWinesInCellar;
		self.resetPairing = resetPairing;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			systemPouch.fetch('distinction').then(function(data){
				self.allDistinctions = data;
			});

			systemPouch.fetch('food').then(function(data){
				self.foods = data;
			});

			systemPouch.fetch('food').then(function(data){
				self.foods = data;
			});

			userPouch.db().allDocs({include_docs: true}).then(function (res) {

				if (res.total_rows){
					var wines = lodash.pluck(res.rows, 'doc');

					var winesInCellar = lodash.filter(wines, function(item) {
						return lodash.get(item, 'cellar.qty', 0) > 0;
					});

					var wineEntities = lodash.map(winesInCellar, function(e){
						return new Wine(e);
					});

					self.wines = wineEntities;
				}

			}).catch(function(err){

				$log.debug('Error getting wines', err);

			});
		}

		function resetPairing(){
			self.selectedFood = null;
		}

		function pairFood(food){

			self.selectedFood = food;

			var distinctions = lodash.filter(self.allDistinctions, function(item) {
				return lodash.contains(item.food, self.selectedFood['_id']);
			});

			self.distinctions = lodash.forEach(distinctions, function (o, key){
				o.cellar = _getWinesInCellarForDistinction(o['_id']);
			});
		}

		function openHelp(){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/pair-food-help.html',
				controller: 'HelpDialogController as dialog'
			});
		}

		function openWinesInCellar(distinction){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/pair-food-wines-in-cellar.html',
				controller: 'PairFoodWinesInCellarDialogController as dialog',
				locals: {
					food: self.selectedFood,
					distinction: distinction,
					wines: distinction.cellar
				}
			});
		}

		function _getWinesInCellarForDistinction(distinctionId){
			if (self.wines.length === 0){
				return null;
			}
			// @todo setup service for this, and maybe use a new pouch/couch view based on cellar qty and food
			return lodash.filter(self.wines, function(item) {
				return item.distinction && item.distinction['_id'] == distinctionId ? true : false;
			});
		}
	}

})();
